import React, { useContext } from "react";
import VehicleList from "./VehicleList";
import s from '../styles/Dashboard.module.css'; 
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { AuthContext } from '../AuthContext';

const Dashboard = () => {
    const {role} = useContext(AuthContext); 
    const navigate = useNavigate();
  
    const handleClick = () => {
      navigate("/add"); // Переход на страницу /add
    };
  
    return (
      <div className={s.container}>
        <div>
          <VehicleList/>
        </div>
        

        {role === "superadmin" || role === "admin" || role === "full" || role === "prefull" || role === "service" || role === "office-manager" ? (
                
                  <button className={s.add_button} onClick={handleClick}>
                    <FaPlus className={s.plus_icon} />
                  </button>   
                    
                ):(
                    <></>
                )}
       
       

      </div>
    );
  };
  

  export default Dashboard;